export function createCustomPopupOverlayClass(OverlayView) {
    return class CustomPopupOverlay extends OverlayView {
        constructor(position, content, map) {
            super();
            this.position = position;
            this.content = content;
            this.containerDiv = document.createElement("div");
            this.containerDiv.classList.add("custom-map-popup");
            this.containerDiv.style.position = "absolute";
            this.containerDiv.appendChild(this.content);
            if (map) this.setMap(map);
        }


        onAdd() {
            const panes = this.getPanes();
            panes.floatPane.appendChild(this.containerDiv);
        }

        draw() {
            const projection = this.getProjection();
            const pos = projection.fromLatLngToDivPixel(this.position);
            if (pos) {
                this.containerDiv.style.left = pos.x + "px";
                this.containerDiv.style.top = pos.y + "px";
            }
        }

        onRemove() {
            if (this.containerDiv.parentElement) {
                this.containerDiv.parentElement.removeChild(this.containerDiv);
            }
        }

        hide() {
            this.containerDiv.style.display = "none";
        }

        show() {
            this.containerDiv.style.display = "block";
        }

        toggle() {
            const display = this.containerDiv.style.display;
            this.containerDiv.style.display = display === "none" ? "block" : "none";
        }
    };
}